import type { QueryClient } from "@tanstack/react-query";
import { ClientKeys } from "web_myplann/Api/Client/ClientKeys";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";

export const invalidateIdentificationDocumentQueries = (
	queryClient: QueryClient,
) => {
	void queryClient.invalidateQueries({
		queryKey: ClientKeys.identificationDocumentsAll,
	});
	void queryClient.invalidateQueries({ queryKey: ClientKeys.all });
	void queryClient.invalidateQueries({
		queryKey: NotificationCenterKeys.all,
	});
	void queryClient.invalidateQueries({ queryKey: RemindersKeys.lists });
};
